import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// Auth components
import {
  Login,
  Signup,
  ConfirmSignup,
  ForgotPassword,
  ResetPassword,
  ProtectedRoute
} from './components/User/Auth';

// Main app component
import AppHandler from './components/AppHandler';

const App: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      {/* Auth routes - redirect to home if already authenticated */}
      <Route path="/auth/login" element={
        isAuthenticated ? <Navigate to="/" replace /> : <Login />
      } />

      <Route path="/auth/signup" element={
        isAuthenticated ? <Navigate to="/" replace /> : <Signup />
      } />

      <Route path="/auth/confirm" element={
        <ConfirmSignup />
      } />

      <Route path="/auth/forgot-password" element={
        <ForgotPassword />
      } />

      <Route path="/auth/reset-password" element={
        <ResetPassword />
      } />

      {/* Main app - visible to everyone, but certain routes require auth */}
      <Route path="/*" element={
        <AppHandler />
      } />

      {/* Catch all - redirect to home */}
      <Route path="*" element={
        <Navigate to="/" replace />
      } />

    </Routes>
  );
};

export default App;
